import { DeleteMappingScope } from "../types/deleteMapping.types";

/**
 * The phrase differs per scope on purpose: it forces the user to read which option is selected
 * before they can act, rather than muscle-memorying a single word past both.
 */
export const DELETE_CONFIRM_PHRASES: Record<DeleteMappingScope, string> = {
  [DeleteMappingScope.CurrentVersion]: "remove current",
  [DeleteMappingScope.AllVersions]: "remove all"
};

export const DELETE_MAPPING_COPY = {
  title: "Remove mapping",
  // Exact wording specified by the ticket -- do not "fix" the grammar.
  description: "Are you sure you want to remove the mapping, after remover cannot recover this data",
  scopeLabel: "What do you want to remove?",
  currentVersionOptionLabel: "Remove the current version only",
  currentVersionOptionDescription: (versionNumber: number | undefined) =>
    `Version ${versionNumber ?? 0} will be deleted. Earlier versions will remain available.`,
  /** Replaces the description above when this is the mapping's only version (T15). */
  onlyVersionDescription: "This is the only version. Removing it deletes the mapping and its chart.",
  /** Replaces the description above when no version has been created for this mapping yet. */
  noVersionYetDescription: "This mapping has no saved versions. Removing it deletes the mapping and its chart.",
  /** Replaces the description above when versions exist but none is flagged active. */
  noDefaultVersionDescription: "No version is currently active, so a single version cannot be removed.",
  allVersionsOptionLabel: "Remove all versions of this mapping",
  allVersionsOptionDescription: "The entire mapping history will be permanently removed.",
  /** Replaces the description above when there is only one version to remove. */
  onlyVersionAllVersionsDescription: "There is no separate history to remove -- use the option above instead.",
  confirmLabel: (requiredPhrase: string) => `Type “${requiredPhrase}” to confirm`,
  confirmPlaceholder: (requiredPhrase: string) => `Type ${requiredPhrase} to continue`,
  confirmHint: "This action cannot be undone. Please confirm by typing the phrase above.",
  cancel: "Cancel",
  submitCurrentVersion: "Remove current version",
  submitAllVersions: "Remove all versions",
  currentVersionSuccess: (versionLabel: string) => `${versionLabel} removed.`,
  /** Shown instead of currentVersionSuccess when removing the version also removed the mapping. */
  mappingRemovedSuccess: "Mapping removed.",
  currentVersionError: "Could not remove this version. Please try again."
} as const;
